<template>
  <div class="jackpot__levels">
    <div class="jackpot__levels-main">
      <jackpot-mega :level="mega" />
    </div>
    <div class="jackpot__levels-items">
      <jackpot-levels-item v-for="(level, key) in dopLevels" :id="key" :key="key" :level="level" />
    </div>
  </div>
</template>

<script setup>
import JackpotMega from 'components/jackpot/JackpotMega.vue'
import JackpotLevelsItem from 'components/jackpot/JackpotLevelsItem.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  levels: {
    type: Array,
    default: () => [],
  },
})
const t = useI18n()
const lang = computed(() => t.locale.value)
const sortedLevels = computed(() => {
  let levels = [...props.levels]?.map((level) => {
    if (level.propsContent.length) {
      let parseProps = JSON.parse(level.propsContent[0]?.props)
      let parseImage = level.propsContent[0]?.images[0]?.compressedImage.webp || null
      return {
        name: parseProps?.[lang.value]?.name || parseProps?.ru?.name || parseProps?.en?.name || '',
        amount: level.amount,
        image: parseImage,
      }
    } else {
      return {
        name: '',
        amount: level.amount,
        image: null,
      }
    }
  })
  return levels.sort((a, b) => b.amount - a.amount)
})

const mega = computed(() => {
  return sortedLevels.value[0]
})
const dopLevels = computed(() => {
  let levels = [...sortedLevels.value]
  levels.shift()
  return levels
})
</script>

<style lang="scss" scoped>
.jackpot__levels {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 12px;
  @include tab {
    flex-direction: row;
    gap: 8px;
  }
  @include desktop {
    flex-direction: column;
    gap: 24px;
    margin-top: 0;
  }

  &-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    @include tab {
      width: calc(50% - 4px);
    }
    @include desktop {
      width: 100%;
    }
  }

  &-items {
    display: flex;
    flex-direction: column;
    gap: 6px;
    line-height: 16px;
    @include tab {
      width: calc(50% - 4px);
    }
    @include desktop {
      width: 100%;
    }
  }
}
</style>
